var map = {
	"./banprime/images/bg-init-left.png": "3241",
	"./ezzebank/images/bg-init-left.png": "0f43",
	"./groovebank/images/bg-init-left.png": "40fc",
	"./hubchain/images/bg-init-left.png": "9951"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9651";